import React, { useEffect } from 'react';
import { Col, Container, Row } from 'reactstrap';
import SidebarLeft from './SidebarLeft';
import SidebarRight from './SidebarRight';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import UiContent from '../../../../Components/Common/UiContent';
import BreadCrumb from '../../../../Components/Common/BreadCrumb';
import Search404 from '../../../AuthenticationInner/Errors/Search';

const DashboardLayout = ({ children, title, hiddenTitle = false }) => {



  return (
    <React.Fragment>
      <UiContent />
      <div className="page-content mb-10" style={{ paddingBottom: '90px' }}>
        <Container fluid>
          <BreadCrumb title={title} hidden={hiddenTitle} />
          <Row>
            {/* <Col lg={2} className='m-0 p-1'>
              <SidebarLeft />
            </Col> */}
            <Col lg={12} className='m-0 p-0'>
              {children}
            </Col>
            {/* <Col lg={2} className='m-0 p-1'>
              <SidebarRight />
            </Col> */}
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default DashboardLayout;
